<template>
  <div class="contentbox">
    <div class="media-add-ep-list">
      <div class="top-search">
        <el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
          <el-form-item label="短剧ID" prop="svId">
            <el-input v-model="formInline.svId" placeholder="请输入短剧ID" clearable @keyup.enter.native="search"
              @clear="search" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="短剧名" prop="svName">
            <el-input v-model="formInline.svName" placeholder="请输入短剧名" clearable @keyup.enter.native="search"
              @clear="search" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
          </el-form-item>
          <el-form-item v-if="!isAgent">
            <el-button type="primary" plain @click="previewGeneralConfig">试看通用配置</el-button>
          </el-form-item><br />
          <el-form-item>
            <el-button type="success" icon="el-icon-plus"  @click="videoConfig">指定剧配置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="tableTh" v-height>
        <el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle">
          <el-table-column prop="" label="序号" width="60">
            <template slot-scope="scope">
              <span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="短剧信息">
            <template slot-scope="scope">
              <div class="td-info" v-if="scope.row.svId">
                <p>短剧名：{{ scope.row.svName }}</p>
                <p>短剧Id：{{ scope.row.svId }}</p>
              </div>
              <div class="td-info" v-else>
                <p>通用配置</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="总剧集数">
            <template slot-scope="scope">
              <div class="td-info">
                <p v-if="scope.row.svId">{{ scope.row.sumEps }}集</p>
                <p v-else>-</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="freeTime" label="试看信息">
            <template slot-scope="scope">
              <div class="td-info">
                <p>试看{{ scope.row.freeTime }}秒</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope" class="ddd">
              <el-button type="primary" plain size="mini" @click="PreviewConfig(scope.row.id)">试看配置</el-button>
              <el-popover width="160" :ref="scope.row.id" style="margin-left: 10px;">
                <p class="popover-con del">
                  <i class="el-icon-question warnning-text"></i>确定删除吗？
                </p>
                <div style="text-align: right;">
                  <el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
                  <el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
                </div>
                <el-button slot="reference" type="danger" plain size="mini">删除</el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div class="foot-table" style="text-align:center;">
          <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
            :page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background :current-page="currentPage"
            layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--试看列表---设置、修改弹框-->
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="700px">
      <el-form :rules="rules" ref="ruleForm" :model="ruleForm" label-width="60px" class="input350" size="small"
        style="max-height: 600px;overflow: auto; padding-right: 20px;">
        <el-form-item label="" prop="freeTime">
          <div class="required-label">
            <div class="mark">*</div>
            <span>待解锁剧集试看（通用）</span>
          </div>
          <div style="margin-top: 8px;">
            <el-input placeholder="" v-model="ruleForm.freeTime" clearable min="0" style="width: 220px;">
              <template slot="append">秒</template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="" prop="haveDetails" v-if="ruleForm.svId">
          <div class="required-label">
            <div class="mark">*</div>
            <span>待解锁剧集试看（特殊剧集）</span>
            <el-switch v-model="ruleForm.haveDetails" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="changeHaveDetails"></el-switch>
          </div>
          <div style="margin-top: 8px;" v-if="ruleForm.haveDetails == 1">
            <ul>
              <li v-for="(item, index) in ruleForm.listDetails" :key="index" style="margin-bottom: 16px;">
                <el-input type="number" v-model="item.epNumber" :min="0" style="width: 180px;">
                  <template slot="prepend">第</template>
                  <template slot="append">集</template>
                </el-input>
                <el-select v-model="item.status" placeholder="请选择" style="width: 150px;margin-left: 16px;">
                  <el-option
                    v-for="ite in statusOptions"
                    :key="ite.value"
                    :label="ite.label"
                    :value="ite.value">
                  </el-option>
                </el-select>
                <el-input placeholder="请输入试看时间" v-if="item.status == 1" v-model="item.freeTime" clearable min="0" style="width: 150px;margin-left: 16px;">
                  <template slot="append">秒</template>
                </el-input>
                <i class="el-icon-circle-plus-outline listDetails-icon" @click="addListDetails"></i>
                <i v-if="index > 0" class="el-icon-delete listDetails-icon" @click="delListDetails(index)"></i>
              </li>
            </ul>
          </div>
        </el-form-item>
        <el-form-item label="" prop="msg1">
          <div>底部文案</div>
          <div style="margin-top: 8px;">
            <el-input v-model.number="ruleForm.msg1" placeholder="请输入底部文案"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="" prop="msg2">
          <div>右侧按钮文案</div>
          <div style="margin-top: 8px;">
            <el-input v-model="ruleForm.msg2" placeholder="请输入右侧按钮文案"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="" prop="msg3">
          <div>左侧按钮文案</div>
          <div style="margin-top: 8px;">
            <el-input v-model="ruleForm.msg3" placeholder="请输入左侧按钮文案"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="">
          <div>样式预览</div>
          <div style="display: flex;align-items: center;">
            <div class="style-preview">
              <span class="tips">试看{{ruleForm.freeTime || 'x'}}秒</span>
              <span class="msg1">{{ruleForm.msg1 || '恭喜获得免费看剧福利，解锁后可继续观看'}}</span>
              <div class="preview-btn">
                <div class="msg3">
                  <span>{{ruleForm.msg3 || '下次再说'}}</span>
                </div>
                <div class="msg2">
                  <span>{{ruleForm.freeTime || 'x'}}秒后 {{ruleForm.msg2 || '试看结束'}}</span>
                </div>
              </div>
            </div>
            <div class="preview-icon">
              <el-button icon="el-icon-view" circle size="medium" @click="onStylePreview"></el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 样式预览 -->
		<el-dialog title="预览" top="5vh" :visible.sync="dialogViewVisible" width="600px">
			<div class="preview-effect">
				<span class="tips">试看{{ruleForm.freeTime || 'x'}}秒</span>
        <span class="msg1">{{ruleForm.msg1 || '恭喜获得免费看剧福利，解锁后可继续观看'}}</span>
        <div class="preview-btn">
          <div class="msg3">
            <span>{{ruleForm.msg3 || '下次再说'}}</span>
          </div>
          <div class="msg2">
            <span>{{ruleForm.freeTime || 'x'}}秒后 {{ruleForm.msg2 || '试看结束'}}</span>
          </div>
        </div>
			</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogViewVisible  = false">确 定</el-button>
      </div>
		</el-dialog>
    <video-table-radio :visible.sync="isShowDialogVideo" :selectVideo="selectVideo" @videoSure="videoSure" @cancelDialogVideo="cancelDialogVideo"></video-table-radio>
  </div>
</template>
<script>
import VideoTableRadio from '@/components/VideoTableRadio'
export default {
  components: {
    VideoTableRadio
  },
  data() {
    return {
      appId: localStorage.getItem('appId'),
      formInline: {
        svId: '',
        svName: ''
      },
      tableData: {
        pageSize: 20,
        pageNo: 1,
        totalPage: 1,
        totalNum: 0,
        result: [
        ]
      },
      currentPage: 1,
      dialogTitle: '',
      dialogFormVisible: false,
      dialogGeneralFormVisible:false,
      ruleForm: {
        appid: localStorage.getItem('appId'),
        freeTime:'',
        haveDetails:0,
        listDetails:[],
        msg1:'恭喜获得免费看剧福利，解锁后可继续观看',
        msg2:'试看结束',
        msg3:'下次再说',
        strategyId:'',
        svId:'',
        id:''
      },
      rules: {
        freeTime: [
          { required: true, message: '请输入试看时间', trigger: 'blur' },
        ],
        haveDetails: [
          { required: true, message: '请设置解锁剧集试看', trigger: 'change' },
        ],
      },
      isShowDialogVideo: false,
      selectVideo: {},
      statusOptions:[
        {
          value: 0,
          label: '不支持试看'
        },
        {
          value: 1,
          label: '支持试看'
        },
      ],
      dialogViewVisible:false,
      isAgent:false,
    }
  },
  computed: {},
  watch: {
  },
  mounted: function () {
    if(JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId){
      this.isAgent = true
    }
    this.getTableData()
  },
  methods: {
    // 关闭选剧弹窗
    cancelDialogVideo(data) {
      console.log('cancel')
      this.isShowDialogVideo = data
    },
    // 确定剧
    videoSure(data) {
      console.log("确定剧",data)
      this.axios({
				method: 'get',
				url: '/video/videoFreeConfig/haveSv',
				params: {
          svId:data.svId
        }
			}).then((response) => {
				if(response.data.head.flag == 0){
          if(response.data.content == 1){
            this.$message.error('列表中已有当前剧的配置，请勿重复添加！');
            return ;
          }else{
            this.isShowDialogVideo = false
            this.ruleForm = {
              appid: localStorage.getItem('appId'),
              freeTime:'',
              haveDetails:0,
              listDetails:[],
              msg1:'恭喜获得免费看剧福利，解锁后可继续观看',
              msg2:'试看结束',
              msg3:'下次再说',
              strategyId:'',
              svId:data.svId,
              id:''
            }
            this.selectVideo = data
            this.dialogTitle = '编辑'
            this.dialogFormVisible = true
          }
				}else{
					this.$message.error(response.data.head.desc);
				}

			})
      
    },
    search() {
      this.currentPage = 1
      this.getTableData()
    },
    resetQuery: function () {
      this.$refs['formInline'].resetFields()
      this.getTableData()
    },
    handleCurrentChange(value) {
      this.currentPage = value
      this.getTableData()
    },
    handleSizeChange(val) {
      this.tableData.pageSize = val
      this.currentPage = 1
      this.getTableData()
    },
    getTableData() {
      let json2 = {
        pageNo: this.currentPage,
        pageSize: this.tableData.pageSize
      };
      let json1 = this.formInline;
      let paramJson = { ...json1, ...json2 };
      this.axios({
				method: 'get',
				url: '/video/videoFreeConfig/getList',
				params: paramJson
			}).then((response) => {
				if(response.data.head.flag == 0){
          this.tableData = response.data.content
				}else{
					this.$message.error(response.data.head.desc);
				}

			})
      
    },

    // 指定剧配置
    videoConfig(){
      this.isShowDialogVideo = true
    },

    // 试看通用设置
    previewGeneralConfig(){
      this.dialogTitle = "通用配置"
      this.ruleForm = {
        appid: localStorage.getItem('appId'),
        freeTime:'',
        haveDetails:0,
        listDetails:[],
        msg1:'恭喜获得免费看剧福利，解锁后可继续观看',
        msg2:'试看结束',
        msg3:'下次再说',
        strategyId:'',
        svId:'',
        id:''
      }
      this.dialogFormVisible = true
    },

    // 弹框确定
    editDialogSureBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveTableData()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 保存编辑信息
    saveTableData() {
      this.axios({
				method: 'post',
				url: '/video/videoFreeConfig/addInfo',
				data: this.ruleForm
			}).then((response) => {
				if(response.data.head.flag == 0){
          this.dialogFormVisible = false
          this.getTableData()
				}else{
					this.$message.error(response.data.head.desc);
				}

			})

    },

    // 列表中---试看设置详情
    PreviewConfig(id){
      this.axios({
				method: 'get',
				url: '/video/videoFreeConfig/details',
				params: {
          infoId:id
        }
			}).then((response) => {
				if(response.data.head.flag == 0){
          this.dialogFormVisible = true
          const {appid, freeTime, haveDetails, listDetails, msg1, msg2, msg3, strategyId, svId, id } = response.data.content
          this.ruleForm = {
            appid,
            freeTime,
            haveDetails,
            listDetails,
            msg1,
            msg2,
            msg3,
            strategyId,
            svId,
            id,
          }
				}else{
					this.$message.error(response.data.head.desc);
				}

			})

    },

    // 删除
    handleDelete(id) {
      console.log(id)
      this.axios({
				method: 'POST',
				url: '/video/videoFreeConfig/delete',
				params: {
          infoId:id
        }
			}).then((response) => {
				if(response.data.head.flag == 0){
          if (this.tableData.result.length === 1 && this.currentPage > 1) {
						this.currentPage = this.currentPage - 1
					}
					this.$refs[id].doClose()
					this.getTableData()
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}else{
					this.$message.error(response.data.head.desc);
				}
      })
    },

    // 是否有特殊剧集
    changeHaveDetails(val){
      if(val == 1){
        this.ruleForm.listDetails.push({
          epNumber:'',
          freeTime:'',
          id:'',
          status:0,
        })
      }else{
        this.ruleForm.listDetails = []
      }
    },

    // 增加特殊剧集设置
    addListDetails(){
      this.ruleForm.listDetails.push({
        epNumber:'',
        freeTime:'',
        id:'',
        status:0,
      })
    },
    // 删除特殊剧集设置
    delListDetails(index){
      this.ruleForm.listDetails.splice(index, 1)
    },
    // 样式预览
    onStylePreview(){
      console.log("样式预览")
      this.dialogViewVisible = true
    }

  }
}
</script>
<style scoped lang="scss">
.required-label{
  position: relative;
  padding-left: 8px;
  box-sizing: border-box;
  .mark{
    color: #ff1c10;
    position: absolute;
    left: 0;
    top: 3px;
  }
}
.listDetails-icon{
  cursor: pointer;
  margin-left: 12px;
}
.style-preview{
  width: 80px;
  height: 138px;
  background-color: #acaaaa;
  border-radius: 6px;
  position: relative;
  .tips{
    line-height: 6px;
    position: absolute;
    bottom: 35px;
    left: 4px;
    font-size: 3px;
    color: #ffffff;
    background-color: rgba(255, 255, 255, 0.3);
    padding: 0 2px;
    border-radius: 1px;
  }
  .msg1{
    font-size: 3px;
    color: #ffffff;
    position: absolute;
    bottom: 15px;
    left: 4px;
  }
  .preview-btn{
    width: 100%;
    line-height: 10px;
    display: flex;
    font-size: 4px;
    position: absolute;
    bottom: 15px;
    left: 4px;
    color: #ffffff;
    .msg3{
      color: #ffffff;
      background-color: rgb(126, 126, 126,0.4);
      border-radius: 2px;
      padding: 0 9px;
    }
    .msg2{
      position: absolute;
      bottom: 0;
      right: 8px;
      color: #1f1f1f;
      background-color: #ffffff;
      border-radius: 2px;
      padding: 0 3px;
    }
  }
}
.preview-icon{
  margin-left: 20px;
  font-size: 20px;
}
.preview-effect{
  width: 390px;
  height: 662px;
  background-color: #acaaaa;
  border-radius: 32px;
  position: relative;
  margin: auto;
  color: #ffffff;
  font-size: 16px;
  .tips{
    position: absolute;
    left: 16px;
    bottom: 150px;
    background-color: rgba(255, 255, 255, 0.3);
    padding: 2px 6px;
    border-radius: 2px;
    font-size: 12px;
  }
  .msg1{
    color: #ffffff;
    position: absolute;
    bottom: 125px;
    left: 16px;
  }
  .preview-btn{
    width: 100%;
    display: flex;
    position: absolute;
    bottom: 65px;
    left: 16px;
    .msg3{
      color: #ffffff;
      background-color: rgb(126, 126, 126,0.4);
      border-radius: 6px;
      padding: 10px 54px;
    }
    .msg2{
      position: absolute;
      bottom: 0;
      right: 32px;
      color: #1f1f1f;
      background-color: #ffffff;
      border-radius: 6px;
      padding: 10px 32px;
    }
  }
}
</style>
